const SITE_NAME = "Clarity Solutions";
const title = (mainTitle: string) => `${mainTitle} | ${SITE_NAME}`;

export const SiteData = {
  COMMON: {
    SITE_NAME,
    SITE_URL: "https://www.clsl.net",
  },
  PAGES: {
    TOP: {
      TITLE: title("Top"),
    },
    CONTACT: {
      TITLE: title("お問合せ"),
    },
    ABOUT: {
      TITLE: title("Clarity Solutionsについて"),
    },
    HAMSTER_RUN: {
      TITLE: title("Hamster Run"),
    },
    SHARE_NINJA: {
      TITLE: title("Share Ninja"),
    },
    DDDOG: {
      TITLE: title("DDDOG"),
    },
    CUBIFOX: {
      TITLE: title("CUBIFOX"),
    },
    NFT_LOGIN: {
      TITLE: title("NFT Login"),
    },
  },
};
